module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, _vm._l((_vm.list), function(item) {
    return _c('div', {
      staticClass: "card-box"
    }, [_c('header', {
      staticClass: "card-name"
    }, [_vm._v("\n      " + _vm._s(item.name) + "\n    ")]), _vm._v(" "), _vm._l((item.children), function(child) {
      return _c('router-link', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "tag": "div",
          "to": {
            path: child.path,
            query: {
              url: child.url
            }
          }
        }
      }, [_c('card', {
        attrs: {
          "title": child.name
        }
      }, [_c('div', {
        slot: "media"
      }, [_c('img', {
        staticStyle: {
          "width": "80%"
        },
        attrs: {
          "src": require("../../assets/2.png"),
          "alt": ""
        }
      })])])], 1)
    })], 2)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-c6bbeac0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/imfbpXd/index.vue
// module id = 510
// module chunks = 1